import React, { useState, useEffect } from 'react';
import { Instruction } from '../services/instructionService';
import styles from './InstructionMarquee.module.scss';
import { BACKEND_BASE_URL } from '../utils/constants';

interface InstructionMarqueeProps {
  instructions: Instruction[];
}

const InstructionMarquee: React.FC<InstructionMarqueeProps> = ({ instructions = [] }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (!instructions || instructions.length === 0) return;

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % instructions.length);
    }, 5000); // Change instruction every 5 seconds

    return () => clearInterval(interval);
  }, [instructions]);

  if (!instructions || instructions.length === 0) {
    return (
      <div className={styles.marqueeContainer}>
        <div className={styles.noInstructions}>
          <p>No active instructions available</p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.marqueeContainer}>
      <div className={styles.marqueeHeader}>
        <h3>📢 Important Instructions</h3>
      </div>
      <div className={styles.marqueeContent}>
        <div className={styles.instructionSlide}>
          <div className={styles.instructionTitle}>
            {instructions[currentIndex]?.title}
          </div>
          {instructions[currentIndex]?.image_url && (
            <div className={styles.instructionImage}>
              <img
                src={BACKEND_BASE_URL + instructions[currentIndex].image_url}
                alt="Instruction"
                className={styles.instructionImageTag}
              />
            </div>
          )}
          <div className={styles.instructionText}>
            {instructions[currentIndex]?.content}
          </div>
        </div>
      </div>
      {instructions.length > 1 && (
        <div className={styles.marqueeIndicators}>
          {instructions.map((_, index) => (
            <button
              key={index}
              className={`${styles.indicator} ${index === currentIndex ? styles.active : ''}`}
              onClick={() => setCurrentIndex(index)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default InstructionMarquee; 